const social = [
    {
        id: 0,
        url: "https://www.linkedin.com/in/chrysalis-woon-38376198/",
        img: "https://github.com/chrysaliswoon/chrysalis-portfolio/blob/main/src/Image%20Assets/linkedin.png?raw=true",
        height: "50px",
        width: "50px",
        alt:"LinkedIn Logo",
    },
    {
        id: 1,
        url: "https://twitter.com/chrysaliswoon",
        img: "https://github.com/chrysaliswoon/chrysalis-portfolio/blob/main/src/Image%20Assets/twitter.png?raw=true",
        height: "50px",
        width: "50px",
        alt:"Twitter Logo",
    },
    {
        id: 2,
        url: "https://github.com/chrysaliswoon",
        img: "https://github.com/chrysaliswoon/chrysalis-portfolio/blob/main/src/Image%20Assets/github.png?raw=true",
        height: "50px",
        width: "50px",
        alt:"Github Logo",
    },
    {
        id: 3,
        url: "mailto:chrysaliswoon@gmail.com",
        img: "https://github.com/chrysaliswoon/chrysalis-portfolio/blob/main/src/Image%20Assets/email.png?raw=true",
        height: "50px",
        width: "50px",
        alt:"Email Logo",
    },
]


export default social